import { get, isEqual } from 'lodash'
import moment, { Moment } from 'moment'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import TimePickerComponent, { parseTime } from '../../TimePicker'

const Wrapper = styled.div``
export type TSelectedDays = {
  from: Date
  to: Date
}
type TTimePicker = {
  start: Moment
  end: Moment
  onChangeStart: (data: Moment) => void
  onChangeEnd: (data: Moment) => void
  isRange: boolean
  selectedDays: TSelectedDays[]
  minDate: string | Moment
  maxDate: string | Moment
  validateTime: boolean
}

const TimePicker = (props: TTimePicker): React.ReactElement => {
  const {
    start,
    end,
    onChangeStart,
    onChangeEnd,
    isRange,
    selectedDays,
    minDate,
    maxDate,
    validateTime = false,
  } = props

  const [startTime, setStartTime] = useState<string | undefined>('0:00')
  const [endTime, setEndTime] = useState<string | undefined>('0:00')
  const [selectedTime, setSelectedTime] = useState(selectedDays)

  const [minTime, setMinTime] = useState('0:00')
  const [maxTime, setMaxTime] = useState('24:00')
  const [isLoad, setIsLoad] = useState(false)

  useEffect(() => {
    setIsLoad(true)
  }, [])

  useEffect(() => {
    if (selectedDays) {
      if (!isEqual(selectedDays, selectedTime)) {
        setSelectedTime(selectedDays)
      }
    }
  }, [selectedDays])

  useEffect(() => {
    if (isLoad && validateTime) {
      const fromDate = get(selectedTime, '0.from')
      const toDate = get(selectedTime, '0.to')
      if (fromDate && minDate) {
        const isSameDay = moment(fromDate).isSame(moment(minDate), 'day')
        if (isSameDay) {
          setMinTime(moment(minDate).format('H:mm'))
        } else {
          setMinTime('0:00')
        }
      }
      if (toDate && maxDate) {
        const isSameDay = moment(toDate).isSame(moment(maxDate), 'day')
        if (isSameDay) {
          setMaxTime(moment(maxDate).format('H:mm'))
        } else {
          setMaxTime('24:00')
        }
      }
    }
  }, [selectedTime, validateTime, isLoad])

  useEffect(() => {
    setStartTime(start ? start.format('H:mm') : undefined)
    setEndTime(end ? end.format('H:mm') : undefined)
  }, [start, end])

  const changeStart = (value): void => {
    const newValue = moment(start)
    const parsed = parseTime(value)
    newValue.hour(Number(parsed.hour))
    newValue.minute(Number(parsed.minute))
    onChangeStart(newValue)
  }

  const changeEnd = (value): void => {
    const newValue = moment(end)
    const parsed = parseTime(value)
    newValue.hour(Number(parsed.hour))
    newValue.minute(Number(parsed.minute))
    onChangeEnd(newValue)
  }

  // const startSplit = startTime.split(":")
  // const [startHour, startMinute] = startSplit

  return (
    <Wrapper className="d-flex mt-2">
      <div
        style={{
          flex: '1',
          marginLeft: '25px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <i className="far fa-clock text-muted" />
        <div>
          <TimePickerComponent
            value={startTime}
            onChange={changeStart}
            minTime={minTime}
            maxTime={!isRange ? maxTime : ''}
          />
          {/* <TimePickerDial time={start} /> */}
        </div>
        <div />
      </div>
      {isRange && (
        <div
          style={{
            flex: '1',
            marginLeft: '25px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <i className="far fa-clock text-muted" />
          <div>
            <TimePickerComponent
              value={endTime}
              onChange={changeEnd}
              maxTime={maxTime}
            />
          </div>
          <div />
        </div>
      )}
    </Wrapper>
  )
}

export default TimePicker
